import React, { useEffect, useState } from 'react'
import AppHeader from '../../components/AppHeader'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import OTPLoginPage from '../../components/OTPLoginPage';
import CustomerCheckinForm from '../../components/checkin/CustomerCheckinForm';
import moment from 'moment';
import { Step, StepLabel, Stepper } from '@mui/material';
import CheckinBackButton from '../CheckinBackButton';
const Step3 = ({queue,service}) =>{
  return (
    <div className='col-md-12 mt-3 mb-5'>
      <Stepper activeStep={2}>
        <Step>
          <StepLabel>{queue.title}</StepLabel>
        </Step>
        <Step>
          <StepLabel>{service.title} For {moment().format("LL")}</StepLabel>
        </Step>
        <Step>
          <StepLabel>Book Token</StepLabel>
        </Step>
      </Stepper>
    </div>
  )
}



function CheckinFormPage() {

  
  const location = useLocation();
  const navigate = useNavigate();
	const {queue,service} = location.state?location.state:{queue:null,service:null};  
  const [customerToken,setCustomerToken] =  useState(localStorage.customerToken);

  useEffect(()=>{
    if(queue===null ){
      navigate("/checkin/queue")
    }
  },[])

  return (
    <>
        <AppHeader/>
        {queue && service &&
        <div className='container'>
          <CheckinBackButton/>
          <Step3 queue={queue} service={service} />
          {
            (customerToken === null || customerToken === undefined)?
              <OTPLoginPage
                setCustomerToken={setCustomerToken}
              /> 
            :
            <CustomerCheckinForm
              queueId={queue.id}
              serviceId={service.id}
              customerToken={customerToken}
            />
          }
        </div>
        }
    </>
  )
}

export default CheckinFormPage